import { lazy } from "react";
import { IRouteDefinition, ISubModuleRoutes } from "../routing";


import AuditsList from './auditoinnit/views/AuditListPage'
import InitializeAuditPage from './auditoinnit/views/InitializeAuditPage';

const FrontPage = lazy(() => import(/* webpackChunkName: 'FrontPage' */"./auditoinnit/views/FrontPage"));
const AuditPage = lazy(() => import(/* webpackChunkName: 'AuditPage' */"./auditoinnit/views/AuditPage"));
const EditAuditPage = lazy(() => import(/* webpackChunkName: 'EditAuditPage' */"./auditoinnit/views/EditAuditPage"));
const PrintAuditPage = lazy(() => import(/* webpackChunkName: 'AnonymousAuditPage' */"./auditoinnit/views/PrintAuditPage"));
const MapPage = lazy(() => import(/* webpackChunkName: 'MapPage' */"./auditoinnit/views/MapPage"));






export enum AuditoinnitRouteId {
    AuditoinnitFrontPage = "auditoinnit-front-page",
    NewAuditPage = "auditoinnit-new-audit",

    AuditPage = "auditointi-audit-page",
    OpenAuditPage = "auditointi-open-audit-page",
    AnonymousAudit = "auditointi-anomyous-audit-page",

    EditAuditPage = "auditointi-edit-audit-page",
    InitializeAuditPage = "auditointi-initialize-audit-page",

    AuditsPage = "auditointi-audits-page",

    AuthRequired = "auditointi-requires-authentication-page",
    MissingRole = "auditointi-missing-correct-role-page",

    ObservationPrint = "auditointi-observation-print-page",
    MapPage = "auditointi-audits-map-page"
};



export const auditoinnitRoutes: IRouteDefinition[] = [
    {
        id: AuditoinnitRouteId.AuditoinnitFrontPage,
        exact: true,
        path: "/",
        render: () => <FrontPage />,
    },


    {
        id: AuditoinnitRouteId.AuditsPage,
        exact: true,
        path: "/auditoinnit",
        render: () => <AuditsList />,
    },
    {
        id: AuditoinnitRouteId.MapPage,
        exact: true,
        path: "/kartta",
        render: () => <MapPage />,
    },


    {
        id: AuditoinnitRouteId.InitializeAuditPage,
        exact: true,
        path: "/uusi-auditointi/:formType/:baseAudit",
        render: () => <InitializeAuditPage />,
    },
    {
        id: AuditoinnitRouteId.EditAuditPage,
        exact: true,
        path: "/auditointi/muokkaa/:audit",
        render: () => <EditAuditPage />,
    },

    /* {
         id: RouteId.EditAuditPage,
         exact: true,
         path: "/auditointi/muokkaa",
         render: () => <EditAuditPage />,
     },*/


    {
        id: AuditoinnitRouteId.AuditPage,
        exact: true,
        path: "/auditointi_:audit",
        render: () => <AuditPage />,
    },

    {
        id: AuditoinnitRouteId.AnonymousAudit,
        requireAuth: false,
        exact: true,
        path: "/anonyymi/auditointi_:package",
        component: PrintAuditPage,
    },



    {
        id: AuditoinnitRouteId.ObservationPrint,
        exact: false,
        path: "/tulosta/havainto",
        render: () => <FrontPage />,
    },
    {
        id: AuditoinnitRouteId.MissingRole,
        exact: true,
        requireAuth: false,
        path: "/ei_oikeutta",
        render: () => <div> Ei oikeutta </div>,
    },

]




const AuditoinnitRouting: ISubModuleRoutes = {
    prefix: "auditoinnit",
    routes: auditoinnitRoutes,
    template: lazy(() => import(/* webpackChunkName: 'AuditoinnitApp' */"./AuditoinnitApp")),
    routeId: AuditoinnitRouteId
}

export default AuditoinnitRouting